/*****
 *
 * A few explainations regarding the Google Analytics flow: TODO: TO UPDATE! BELOW IS DEPRECATED
 *
 * On render, the default connection status is DataSourcesModel.CONNECTION_STATUS.UNKNOWN
 * The system will first check if the GA secret is delivered. Call of isConnectedToGoogle().
 * On fetch success:
 * - if status is disconnected, it will get the GA approval url by calling getGoogleAnalyticsApprovalUrl().
 * This url will be used when the user will press on the GA corresponding Connect button.
 * On fetch success, it will call syncExtraConnections() which will store in the  model the corresponding url
 * - if status is connected it will call syncExtraConnections() and update the model with the  corresponding connection status (true or false).
 * The status is displayed accordingly in the TableRowView (it listens to a change in the model).
 *
 * If Not Connected (DataSourcesModel.CONNECTION_STATUS.NONE) and the user clicks on the Connect button,
 * the system will first call the doConnectToGoogle() which will:
 * - call the prepareAfterGrantAccess() which defines the CB function called if GA Access is granted by Google
 * - open a new GA Login window. The url is retrieved from the model.
 * If granted, GA issues a token cbURLWithTheTokenParam and the system triggers an event to call connectToGoogle() API by passing the token.
 * On fetch success, connection is set successfully (secret is delivered) and we call the syncExtraConnections() and update the model with the corresponding connection status
 *
 * If GA Connected and if the user clicks on the Disconnect link,
 * the system will first get the GA approval url by calling getGoogleAnalyticsApprovalUrl() and update the model accordingly.
 * it will then call doDisconnectToGoogle() which will display a notifier confirm dialog.
 * If confirmed, disconnectGoogleAccount() API will be called.
 * On fetch success it will call the syncExtraConnections() and update the model with the corresponding connection status
 *
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var ManagerConfig = require("manager-assets/config/managerConfig.json");
    var ApiResources = require("assets/data/apiResources.json");
    var LEResourceResolver = require("leResourceResolver");
    var BaseModel = require("models/BaseModel");

    var DataSourcesAnalyticsController = {};

    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {

        DataSourcesAnalyticsController = Marionette.Controller.extend({

            initialize: function(){
                this.vent = LEManager.media.channel("dataSources").vent;
            },

            bindToGoogleAnaliticsEvents: function(){
                this.listenTo(this.vent, ManagerConfig.dataSources.mainConfig.webAnalytics.TRIGGERING.DISCONNECT_CONNECTORS_CLICK, this.doDisconnectToGoogle);
            },

            isConnectedToGoogle: function(){
                var that = this;
                var oauthModel = new BaseModel();

                oauthModel.resource = ApiResources.AnalyticsDataSources.googleAnalytics.url;

                var options = {
                    success:function (model, response, xhr) {
                        var connected = model.attributes.connected;
                        if (!connected) {
                            that.getGoogleAnalyticsApprovalUrl();
                        }
                        else {
                            that.vent.trigger(ManagerConfig.dataSources.mainConfig.root.TRIGGERING.SYNC_CONNECTORS_CONNECTIONS, [{id: ManagerConfig.dataSources.mainConfig.dataSourceTypes.WEB_ANALYTICS, isConnected: connected}]);
                        }
                    },
                    error:function (model, errors) {
                        LEManager.logger.error("DataSourcesAnalyticsController:isConnectedToGoogle error");
                        LEManager.notifier.showError(LE.translator.translate("LEFramework.ConnectionError"));
                    }
                };

                oauthModel.fetch(options);
            },

            getGoogleAnalyticsApprovalUrl: function(){
                var that = this;
                var Model = BaseModel.extend({ resource: this.getOAuthResource() });
                var connectionDashboardModel = new Model();
                var options = {
                    headers:{
                        'Content-Type':'application/json'
                    },
                    success:function (data) {
                        that.vent.trigger(ManagerConfig.dataSources.mainConfig.root.TRIGGERING.SYNC_CONNECTORS_CONNECTIONS, [{id: ManagerConfig.dataSources.mainConfig.dataSourceTypes.WEB_ANALYTICS, isConnected: false}], {url: data.attributes.url});
                    },
                    error:function (data, xhr) {
                        LEManager.logger.error("DataSourcesAnalyticsController:getGoogleAnalyticsApprovalUrl error");
                        LEManager.notifier.showError(this.LE.translator.translate("LEFramework.ConnectionError"));
                    }
                };
                connectionDashboardModel.fetch(options);
            },

            prepareAfterGrantAccess: function() {
                var that = this;
                if (!window.oauth2) {
                    window.oauth2 = {};
                }
                window.oauth2.afterGrantAccess = function (e) {
                    if (e && e.source === that.googleWindow) {
                        that.connectToGoogle(e.data);
                        that.closeOAuthWindow();
                        if (window.removeEventListener) {
                            window.removeEventListener('message', window.oauth2.afterGrantAccess, false);
                        } else {
                            window.detachEvent('onmessage', window.oauth2.afterGrantAccess);
                        }
                    }
                };

                if (window.addEventListener) {
                    window.addEventListener('message', window.oauth2.afterGrantAccess, false);
                } else {
                    window.attachEvent('onmessage', window.oauth2.afterGrantAccess);
                }
            },

            closeOAuthWindow: function() {
                if (this.googleWindow != null) {
                    this.googleWindow.close();
                }
            },

            openGoogleWindow: function(accessUrl) {
                this.prepareAfterGrantAccess();
                this.googleWindow = LE.navigator.getActiveRouter().open(accessUrl, "Google", "width=800,height=600");
            },

            connectToGoogle: function (cbURLWithTheTokenParam) {
                var that = this;
                var oauthModel = new BaseModel();
                oauthModel.resource = ApiResources.AnalyticsDataSources.googleAnalytics.url;

                var tokenParam = this.extractTokenParam(cbURLWithTheTokenParam);

                if (tokenParam) {
                    var options = {
                        success:function (model, response, xhr) {
                            that.vent.trigger(ManagerConfig.dataSources.mainConfig.root.TRIGGERING.SYNC_CONNECTORS_CONNECTIONS, [{id: ManagerConfig.dataSources.mainConfig.dataSourceTypes.WEB_ANALYTICS, isConnected: true}]);
                            LEManager.notifier.showSuccess({
                                content: LE.translator.translate("LEFramework.ConnectionSuccess")
                            });
                        },
                        error:function (model, errors) {
                            LEManager.logger.error("DataSourcesAnalyticsController:connectToGoogle error");
                            LEManager.notifier.showError({
                                content: LE.translator.translate("LEFramework.ConnectionError")
                            });
                        }
                    };

                    oauthModel.set("code", tokenParam);
                    oauthModel.set("redirectURI", this.getRedirectURI());

                    oauthModel.save(null, options);
                } else {
                    LEManager.logger.error("DataSourcesAnalyticsController:connectToGoogle error");
                    LEManager.notifier.showError(this.LE.translator.translate("LEFramework.ConnectionError"));
                }
            },

            extractTokenParam: function(cbURLWithTheTokenParam){
                var strArray = cbURLWithTheTokenParam.split("code=");
                if(strArray.length===2) {
                    return strArray[1];
                } else {
                    return undefined;
                }
            },

            doConnectToGoogle: function(model){
                if (this.googleWindow && !this.googleWindow.closed) {
                    this.googleWindow.focus();
                } else {
                    var accessUrl = model.getConnectorConfig()[ManagerConfig.dataSources.mainConfig.webAnalytics.GOOGLE_ANALYTICS_ACCESS_URL];
                    this.openGoogleWindow(accessUrl);
                }

            },

            doDisconnectToGoogle: function(){
                this.showConfirmDisconnect();
            },

            disconnectGoogleAccount: function(){
                var that = this;
                var oauthModel = new BaseModel();

                oauthModel.resource = ApiResources.AnalyticsDataSources.googleAnalyticsDelete.url;

                var options = {
                    success:function (model, response, xhr) {
                        that.getGoogleAnalyticsApprovalUrl();
                    },
                    error:function (model, errors) {
                        LEManager.logger.error("DataSourcesAnalyticsController:disconnectGoogleAccount error");
                        LEManager.notifier.showError(LE.translator.translate("LEFramework.ConnectionError"));
                    }
                };

                oauthModel.save(null, options);
            },

            getRedirectURI: function(){
                // return a URL to the latest version, since its whitelsited in Google
                return LEResourceResolver.getResourceBaseUrl().replace(/lp-le-ui\/([^/]*)/, 'lp-le-ui/latest/') + 'html/oauthWindow.html';
            },

            getOAuthResource: function(){
                return LEResourceResolver.extendResourceWithOptions.call(this, ApiResources.AnalyticsDataSources.googleAnalyticsOAuth, {redirectURI:this.getRedirectURI()});
            },

            showConfirmDisconnect: function() {
                var that = this;
                var title = LE.translator.translate("LEFramework.DisconnectConfirmTitle");
                var actionText = LE.translator.translate("LEFramework.DisconnectActionText");
                var message = LE.translator.translate("LEFramework.DisconnectConfirmMessage");

                LEManager.notifier.showConfirm({
                    title: title,
                    content: message,
                    objectAction: {
                        text: actionText,
                        callback: function() {
                            that.disconnectGoogleAccount();
                        }

                    }
                });
            }


        });

    });

    return DataSourcesAnalyticsController;
});
